// extracted by mini-css-extract-plugin
export default {"container":"Slide_container__5tIh0","warning":"Slide_warning__0hbmf","normal":"Slide_normal__Tu1eJ"};